<template lang="pug">
  .resp-img(:class="{'absolute inset-0': bg && useHeight}")
    //- background image
    template(v-if="bg")
      //- lazy bg
      template(v-if="lazy")
        .absolute.inset-0.h-full.bg-no-repeat(v-if="thumb", v-lazy:background-image="thumb", :class="bgClass", role="img", :aria-label="alt")
      //- bg
      .absolute.inset-0.h-full.bg-no-repeat(v-else, :style="'background-image:url(' + thumb + ')'", :class="[bgClass, {'opacity-0': !loaded}]", role="img", :aria-label="alt")
        //- hidden img to know when @loaded
        img.hidden(:src="thumb", @load="loaded = true", :alt="alt", @error="onError")
    //- <img>
    template(v-else)
      img.block(v-if="lazy && thumb", v-lazy="thumb", :alt="alt", :class="imgClass", @error="onError")
      img.block.trans-opacity-quick(v-else, :src="thumb", :alt="alt", :class="[imgClass, {'opacity-0': !loaded}]", @load="loaded = true", @error="onError")
</template>

<script>
import { thumbSrc } from '@/utils'
export default {
  name: 'RespImg',
  inheritAttrs: false,
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
    lazy: { type: Boolean, default: false },
    bg: { type: Boolean, default: false },
    imgClass: { type: String, default: 'w-full' },
    bgClass: { type: String, default: 'bg-cover bg-center bg-no-repeat' },
    useHeight: { type: Boolean, default: false }
  },
  data () {
    return {
      length: -1,
      loaded: false,
      thumb: false
    }
  },
  methods: {
    resize (src = null) {
      return src && src.length && thumbSrc(src, this.length, this.useHeight)
    },
    setLength () {
      if (this.length > 0) return
      this.length = this.bg && this.useHeight ? this.$el.offsetHeight : this.$el.offsetWidth
    },
    setThumb () {
      this.thumb = this.resize(this.src)
    },
    onError () {
      console.warn('Thumb failed, loading source image:', this.src)
      this.thumb = this.src
      this.loaded = true
    }
  },
  mounted () {
    this.setLength()
    this.setThumb()
    this.$store.state.bus.$on('newWindowWidth', this.setLength)
  },
  destroyed () {
    this.$store.state.bus.$off('newWindowWidth', this.setLength)
  }
}
</script>

<style>
.resp-img{
  & [lazy], & [role="img"] { transition: opacity 500ms; }
  & [lazy="loading"]{ opacity:0; }
  & [lazy="loaded"]{ opacity:1; }
}
</style>
